function GetRequest(url, cb) {
  var xhttp = new XMLHttpRequest();
  xhttp.withCredentials = true;
  xhttp.onreadystatechange = function() {
    if (this.readyState === 4)
     cb(this);
  };
  xhttp.open("GET", url, true);
  xhttp.send();
}

function PostRequest(url, params, cb){
  var xhttp = new XMLHttpRequest();
  xhttp.withCredentials = true;
  var data = JSON.stringify(params);
  xhttp.open("POST", url, true);
  xhttp.onreadystatechange = function(){
    if(this.readyState === 4) cb(this);
  }
  xhttp.send(data);
}

function PatchRequest(url, params, cb){
  var xhttp = new XMLHttpRequest();
  xhttp.withCredentials = true;
  var data = JSON.stringify(params);
  xhttp.open("PATCH", url, true);
  xhttp.onreadystatechange = function(){
    if(this.readyState === 4) cb(this);
  }
  xhttp.send(data);
}

function PutRequest(url, params, cb){
  var xhttp = new XMLHttpRequest();
  xhttp.withCredentials = true;
  var data = JSON.stringify(params);
  xhttp.open("PUT", url, true);
  xhttp.onreadystatechange = function(){
    if(this.readyState === 4 ) cb(this);
  }
  xhttp.send(data);
}

function DeleteRequest(url, params, cb) {
  var xhttp = new XMLHttpRequest();
  xhttp.withCredentials = true;
  var data = JSON.stringify(params);
  xhttp.open("DELETE", url, true);
  xhttp.onreadystatechange = function() {
    if (this.readyState === 4) {
      cb(this);
    }
  };
  xhttp.send(data);
}

module.exports = {
  GetRequest: GetRequest,
  PostRequest: PostRequest,
  PatchRequest: PatchRequest,
  PutRequest: PutRequest,
  DeleteRequest: DeleteRequest,
};